enum ChartValueType {
  Unspecified,
  Number,
  Monetary,
}

export { ChartValueType };
